import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { NODE_TYPE } from '../../../PowertrainTools/PowertrainConfigurationV2/Hierarchy/constants';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import { IconDragEqual } from 'svgIcons/MotionPortalIcons';

const getSpecialNodeLabelKey = (nodeType) => {
    if (nodeType === NODE_TYPE.UNASSIGNED_ASSETS) {
        return 'ABB.Powertrain.Frontend.singleAssetsLabel';
    }
    if (nodeType === NODE_TYPE.UNASSIGNED_POWERTRAINS) {
        return 'ABB.Powertrain.Frontend.powertrainsNotInHierarchy';
    }
    return null;
};

const getCountFromNodeName = (name) => name?.match(/\((\d+)\)\s*$/)?.[1];

const HierarchyNodeContent = React.memo(({
    node,
    renderActions,
    isOver,
    childNodeCount,
    showDragPreview
}) => {
    const nodeType = node?.data?.type;
    const specialNodeLabelKey = getSpecialNodeLabelKey(nodeType);
    const nodeName = specialNodeLabelKey ? translate(specialNodeLabelKey) : node?.name;
    let nodeCount = childNodeCount;
    if (nodeType === NODE_TYPE.UNASSIGNED_ASSETS) {
        nodeCount = node.data?.assetCount ?? getCountFromNodeName(node.name) ?? childNodeCount;
    } else if (nodeType === NODE_TYPE.UNASSIGNED_POWERTRAINS) {
        nodeCount = node.data?.powertrainCount ?? getCountFromNodeName(node.name) ?? childNodeCount;
    }
    const displayNodeName = nodeCount ? `${nodeName} (${nodeCount})` : nodeName;

    return (
        <>
            <div className='hierarchy-node-content-default'>
                <div className='hierarchy-node-name-container'>
                    <span className='hierarchy-node-name' title={displayNodeName}>
                        {displayNodeName}
                    </span>
                    {node?.data?.type === NODE_TYPE.UNASSIGNED_ASSETS &&
                        <span className='hierarchy-node-description'>
                            {translate('ABB.Powertrain.Frontend.assetsNotYetInAPowertrain')}
                        </span>
                    }
                    {node?.data?.type === NODE_TYPE.UNASSIGNED_POWERTRAINS &&
                        <span className='hierarchy-node-description'>
                            {translate('ABB.Powertrain.Frontend.powertrainsNotYetInALocationGroup')}
                        </span>
                    }
                </div>
                {/* Actions */}
                {renderActions && !isOver &&
                    <div className='hierarchy-node-actions'>
                        {renderActions(node)}
                    </div>
                }
            </div>
            {showDragPreview &&
                <GeneralButton
                    className='drag-icon'
                    type='normal'
                    text={''}
                    icon={IconDragEqual({ width: '16px', height: '16px' })}
                />
            }
        </>
    );
});

HierarchyNodeContent.propTypes = {
    node: PropTypes.object.isRequired,
    renderActions: PropTypes.func,
    isOver: PropTypes.bool,
    childNodeCount: PropTypes.number,
    showDragPreview: PropTypes.bool,
};

HierarchyNodeContent.defaultProps = {
    renderActions: null,
    isOver: false,
    childNodeCount: 0,
    showDragPreview: false,
};

HierarchyNodeContent.displayName = 'HierarchyNodeContent';

export default HierarchyNodeContent;
